import React from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";

const MODES = ["development", "strength"];

const NetworkPairingModeSelector = ({ mode, onChange }) => (
  <ButtonGroup
    isAttached
    width={{ base: "100%", sm: "auto" }}
    role="group"
    aria-label="Pairing result type"
  >
    {MODES.map((value) => (
      <Button
        key={value}
        flex={{ base: 1, sm: "initial" }}
        minW={{ sm: "128px" }}
        onClick={() => onChange(value)}
        variant={mode === value ? "solid" : "outline"}
        colorScheme={mode === "strength" ? "green" : "red"}
        aria-pressed={mode === value}
      >
        {value === "development" ? "Development" : "Strength"}
      </Button>
    ))}
  </ButtonGroup>
);

export default NetworkPairingModeSelector;
